/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useState} from "react";
import useSub from "./useSub.jsx";
import {useDidMount} from "./useDidMount.jsx";
import {Socket} from "../Socket.js";
import useCompareEffect from "./useCompareEffect.jsx";
import {Containers} from "../Objects/Containers.jsx";

function useContainer(containerId) {
    const [containerInfo, setContainerInfo] = useState({})

    async function fetchData() {
        let container = await Containers(containerId).getInfo()
        setContainerInfo(container ?? {})
    }

    useDidMount(() => {
        fetchData()
    })

    useCompareEffect(() => {
        fetchData()
    }, [containerId])

    useSub(() => Database.table("Container", "app").onChange((change) => {
        let updated = Socket.applyChange([containerInfo], change)[0]
        setContainerInfo(updated ?? {})
    }, [{
        column: "containerId", value: containerId
    }]), "liveContainerData")

    return containerInfo
}

export default useContainer;